/* breadcrumb
========================================================*/

export function initBreadcrumbFunctions() {
    $(function() {
        const pathArray = window.location.pathname
            .split('/')
            .filter(Boolean)
            .filter(function(seg) { return seg !== 'index.php'; });

        const $h1 = $('h1').first();
        const pageName = $h1.length
            ? $h1.text().replace(/\s+/g, ' ').trim()
            : (document.title.includes('|') ? document.title.split('|')[0].trim() : document.title);

        const $currentContainer = $('.jsBreadcrumbCurrent');
        if ($currentContainer.length && pageName) {
            $currentContainer.find('.text').text(pageName);
        }

        const $middleLi = $('#jsBreadcrumbMiddle');

        if (pathArray.length >= 2 && $middleLi.length) {
            const parentDir = pathArray[0];
            const parentUrl = '/' + parentDir + '/';

            fetch(parentUrl)
                .then(function(res) {
                    return res.ok ? res.text() : Promise.reject(res.status);
                })
                .then(function(html) {
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(html, 'text/html');
                    const parentH1 = doc.querySelector('h1');
                    const parentName = parentH1
                        ? parentH1.textContent.replace(/\s+/g, ' ').trim()
                        : parentDir;
                    $middleLi.find('a').attr('href', parentUrl).text(parentName);
                    $middleLi.show();
                })
                .catch(function() {
                    $middleLi.find('a').attr('href', parentUrl).text(parentDir);
                    $middleLi.show();
                });
        }
    });
}